namespace GeniuzPOS.ReportMasterData {
    export interface Report_1504Form {
    }

    export class Report_1504Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1504';
    }
}
